import { Helmet } from 'react-helmet'
import { useSession } from 'contexts/session-context'
import useRouter from 'hooks/use-router'
import useRedirect from 'hooks/use-redirect'
import Hero from './components/Hero'
import IntroSection from './components/IntroSection'
import WhatAreSection from './components/WhatAreSection'
import PrizesSection from './components/PrizesSection'
import HowToParticipate from './components/HowToParticipate'
import CalendarSection from './components/CalendarSection'
import BadgeVideoSection from './components/BadgeVideoSection'
import PitStopsSection from './components/PitStopsSection'
import F1Picture from './components/F1Picture'
import { F1_MOBILE_ASSETS, PIT_STOPS_ANCHOR_ID } from './constants'

const SEO_TITLE = 'F1 Pit Stops | My Heineken'
const SEO_DESCRIPTION =
  'Heineken te lleva a la experiencia más exclusiva de F1®. Completa los Pit Stops semanales y participa por pases dobles a Foro Sol y al Paddock.'

const Pitstops = () => {
  const [{ user }] = useSession()
  const { push, pathname } = useRouter()
  const [, { setRedirect }] = useRedirect()

  const isLogged = user !== undefined

  // Visitors go register/log in (login-manager, same flow the client wired
  // for Neighbars) and come back here via internal_redirect; logged users
  // are taken to the Pit Stops modules section further down the page.
  const handleParticipate = () => {
    if (!isLogged) {
      setRedirect(pathname)
      push('/login-manager?tointernal=true')
      return
    }
    document.getElementById(PIT_STOPS_ANCHOR_ID)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="pitstops">
      <Helmet>
        <title>{SEO_TITLE}</title>
        <meta name="description" content={SEO_DESCRIPTION} />
        <meta property="og:title" content={SEO_TITLE} />
        <meta property="og:description" content={SEO_DESCRIPTION} />
        <meta property="og:image" content={encodeURI(`${F1_MOBILE_ASSETS}/hero-mobile.webp`)} />
        <meta property="og:type" content="website" />
      </Helmet>
      <Hero />
      <IntroSection onCtaClick={handleParticipate} />
      <WhatAreSection />
      {/* Single tall block (Figma 5595:12093): the diagonal-bars artwork is
          one baked background shared by prizes, steps and calendar */}
      <section className="pitstops__race">
        <F1Picture
          name="como_participar-background"
          pictureClassName="pitstops__race-bg"
          className="pitstops__race-bg-media"
        />
        <PrizesSection />
        <HowToParticipate onCtaClick={handleParticipate} />
        <CalendarSection />
      </section>
      <BadgeVideoSection />
      <PitStopsSection isLogged={isLogged} onCtaClick={handleParticipate} />
    </div>
  )
}

export default Pitstops
